// Components==============
import React from 'react';
import { useSelector } from 'react-redux';
import { getDeviceInfo } from 'utilities/getDeviceInfo';
import './Info.module.scss';
// =========================

export default function Info() {
    const deviceInfo = getDeviceInfo();

    const user = useSelector((state: ReduxStore) => {
        if (!state.authentication?.user) return {};
        const { id, name, role, treatments } = state.authentication?.user;

        const activeTreatment = treatments.find((t) => t?.pivot?.open)?.id || 0;

        return { id, name, role, activeTreatment };
    });

    return (
        <div styleName="wrapper">
            {Object.entries({ ...user, ...deviceInfo }).map(
                ([key, value], index) =>
                    value && (
                        <p key={index}>
                            <b>{key}</b>: {value}
                        </p>
                    )
            )}
        </div>
    );
}
